export default __webpack_public_path__ + "static/media/provincia_icon_Footer.78ac22d2.png";